export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="aspect-square rounded-2xl overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/f77f6aa78adb73f9994f91e3447ad68f/656900bb8d2765cbde8d71477e8553fa.png"
                alt="Noah - Professional creative designer"
                className="w-full h-full object-cover"
                style={{ objectPosition: '65% 70%' }}
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-gradient-to-br from-teal-500 to-blue-600 rounded-2xl -z-10"></div>
          </div>

          <div>
            <div className="inline-block mb-4">
              <span className="px-4 py-2 bg-teal-50 text-teal-600 rounded-full text-sm font-semibold">
                About Me
              </span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Passionate About Creating Digital Content about nature
            </h2>
            
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              I am a creative and detail-oriented person with a deep passion for nature and wildlife, particularly reptiles and marine life. I have experience in digital design and have created several app concepts using Figma, which reflects both my technical skills and design sensibility. I also enjoy producing videos with AI, blending technology and creativity to craft engaging visual content. I am always eager to learn and explore new tools that allow me to connect technology with my love for the natural world.
            </p>

            <div className="grid grid-cols-3 gap-6 mb-8">
              <div className="flex items-start gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-50 rounded-lg flex-shrink-0">
                  <i className="ri-team-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900 text-lg">Team Player</div>
                  <div className="text-gray-600 text-sm">Collaborative approach</div>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-50 rounded-lg flex-shrink-0">
                  <i className="ri-lightbulb-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900 text-lg">Innovative</div>
                  <div className="text-gray-600 text-sm">Creative solutions</div>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-orange-50 rounded-lg flex-shrink-0">
                  <i className="ri-time-line text-2xl text-orange-600"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900 text-lg">Reliable</div>
                  <div className="text-gray-600 text-sm">On-time delivery</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
